// ** React Imports
import React, { lazy, Suspense, useEffect } from "react";

// ** Router Components
import { BrowserRouter as AppRouter, Route, Routes, useLocation } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import SignIn from "../views/Auth/SignIn";
import SignUp from "../views/Auth/SignUp/SignUp";
import "./index.css";

import TagManager from 'react-gtm-module';

import Home from "../views/Home";
import PrivacyPolicy from "../views/PrivacyPolicy";
import TermsOfService from "../views/TermsOfService";
import TermsOfSale from "../views/TermsOfSale";
import RefundPolicy from "../views/RefundPolicy";
import Documents from "../views/Documents";
import PaymentPolicy from "../views/PaymentPolicy";
import CookieTrackingPolicy from "../views/Cookie&TrackingPolicy";
import ContactComplainPolicy from "../views/ContactComplainPolicy";
import AboutUs from "../views/AboutUs";
import CartList from "../views/CartList";
import Careers from "../views/Careers";
import UserDeletion from "../views/UserDeletion";
import DataProtectionPolicy from "../views/DataProtectionPolicy";
import OrderFailurePage from "../views/PaymentPages/Failure";
import OrderCancelledPage from "../views/PaymentPages/Cancel";
import PaymentSuccess from "../views/PaymentPages/Success";
import IosPrivacyPolicy from "../views/IosPrivacyPolicy";
import DeliveryMapConfirm from "../views/DeliveryMapConfirm";
import PickupMapConfirm from "../views/PickupMapConfirm";
import PayByCard from "../views/PayByCard";
import PayByCardSuccess from "../views/PaymentPages/PayByCardSucess";
import HomeRoute from "../views/HomeRoute";
import PrivacyPolicyCartApp from "../views/PrivacyPolicyCartApp";

const Error = lazy(() => import("../views/Error"));
const Menu = lazy(() => import("../views/Menu"));
const MyOrders = lazy(() => import("../views/MyOrders"));
const MyCart = lazy(() => import("../views/MyCart"));
const Contact = lazy(() => import("../views/Contact"));
// const Home = lazy(() => import("../views/Home"));
const UserProfile = lazy(() => import("../views/UserProfile"));
const OrderDetails = lazy(() => import("../views/OrderDetails"));
const OurPromisePage = lazy(() => import("../views/OurPromise"));
const AutoLogin = lazy(() => import("../views/Auth/AutoLogin"));

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const dataLayerArgs = {
      dataLayer: {
        event: 'pageview',
        page: location.pathname + location.search,
      },
    };
    TagManager.dataLayer(dataLayerArgs);
  }, [location]);

  return null;
};

const Router: React.FC = () => {

  return (
    <AppRouter>
      <PageViewTracker />
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/auto-login" element={<AutoLogin />} />
          <Route path="*" element={<Error />} />
          <Route path="/qr" element={<HomeRoute />} />

          {/* --------- Nav Bar ------------ */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Menu />} />
            <Route
              path="order"
              element={
                <div className="fade-in">
                  <Menu />
                </div>
              }
            />
            <Route
              path="orders"
              element={
                <div className="fade-in">
                  <Menu />
                </div>
              }
            />
            <Route
              path="menu"
              element={
                <div className="fade-in">
                  <Menu />
                </div>
              }
            />
            <Route path="home" element={<Home />} />
            <Route path="onlineOrders" element={<MyOrders />} />
            <Route path="shoppingCart" element={<MyCart />} />
            <Route path="documents" element={<Documents />} />
            <Route
              path="contact"
              element={
                <div className="fade-in">
                  <Contact />
                </div>
              }
            />
            <Route
              path="our-promise"
              element={
                <div className="fade-in">
                  <OurPromisePage />
                </div>
              }
            />
            <Route path="profile" element={<UserProfile />} />
            <Route path="order-details" element={<OrderDetails />} />
            <Route path="delivery-location" element={<DeliveryMapConfirm />} />
            <Route path="pickup-location" element={<PickupMapConfirm />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="privacy-policy-cart-app" element={<PrivacyPolicyCartApp />} />
            <Route path="terms-of-service" element={<TermsOfService />} />
            <Route path="terms-of-sale" element={<TermsOfSale />} />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="payment-policy" element={<PaymentPolicy />} />
            <Route path="cookie-tracking-policy" element={<CookieTrackingPolicy />} />
            <Route path="contact-complain-policy" element={<ContactComplainPolicy />} />
            <Route path="data-protection-policy" element={<DataProtectionPolicy />} />
            <Route path="ios-privacy-policy" element={<IosPrivacyPolicy />} />

            <Route path="about-us" element={<AboutUs />} />
            <Route path="carts" element={<CartList />} />
            <Route path="cart" element={<CartList />} />
            <Route path="pay-by-card" element={<PayByCard />} /> 
            <Route path="careers" element={<Careers />} />
            <Route path="user-self-deletion" element={<UserDeletion />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-success/card" element={<PayByCardSuccess />} />
            <Route path="/payment/failure" element={<OrderFailurePage />} />
            <Route path="/payment/cancel" element={<OrderCancelledPage />} />

          </Route>
          {/* --------- Nav Bar ------------ */}
        </Routes>
      </Suspense>
    </AppRouter>
  );
};

export default Router;
